//ZimbraInstanceSearch
import { HttpParams }   from '@angular/common/http';
import AbstractZimbraInstanceSearch       from './AbstractZimbraInstanceSearch';
import { FormControl }  from '@angular/forms';

export default class ZimbraInstanceSearch extends AbstractZimbraInstanceSearch
{
    
    constructor(dict = null)
    {
        super(dict);
        if (dict !== null)
        {
        }
    }
    
    getHttpParams()
    {
      var params = super.abstractBuildHttpParams()
      return params;
    }
}
